import { render, staticRenderFns } from "./AmendmentMessages.vue?vue&type=template&id=47fbfb9c&scoped=true&"
import script from "./AmendmentMessages.vue?vue&type=script&lang=js&"
export * from "./AmendmentMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fbfb9c",
  null
  
)

export default component.exports